$ = jQuery.noConflict();

var Postulez = {
    init:function(){
        console.log("________POSTULEZ INIT__________");
        //map = new google.map
        $("#newsrh").keyup(function(){
            console.log($(this).val());
            $("#edit-field-email-0-value--2").val($(this).val());
        });

        $('.nl-form').on('submit', function(ev){
            ev.preventDefault();
            $('#block-contactblock-4').find('form').submit();
        });
        $('.cv .btn').on('click', function(){
            $('.zoho-form').css('display', 'flex');
        });
        $('.close-zoho').on('click', function(){
            $('.zoho-form').hide();
        });
    },
}

$(document).ready(function(){
    if($('#postulez-offres').length > 0){
        Postulez.init();
    }
});